// API请求配置和工具函数
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000';

// 创建axios实例
export const api = axios.create({
  baseURL: API_BASE_URL,
});

// 添加请求拦截器，自动添加API Key
api.interceptors.request.use((config) => {
  const apiKey = localStorage.getItem('apiKey');
  if (apiKey) {
    config.headers['x-api-key'] = apiKey;
  }
  return config;
});

// 添加响应拦截器，处理401错误
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // 只有在已登录状态下收到401错误才跳转
    // 登录页面的401错误应该正常处理，不要跳转
    if (error.response?.status === 401) {
      const currentPath = window.location.pathname;
      const isLoginPage = currentPath === '/login' || currentPath === '/register';
      
      if (!isLoginPage) {
        localStorage.removeItem('apiKey');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);